module.exports = __webpack_public_path__ + "img/left-girl1.42fb8aa8.svg";